/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { baseAuthHeaders } from "#/modules/auth/idp";

export type MeRole = {
  role: string;
  scope_type: string;
  scope_id: string;
};

export type MeAccessSummary = {
  roles: MeRole[];
  customer_count: number;
  license_count: number;
  default_customer_id: string | null;
  default_license_id: string | null;
};

export type MeResponse = {
  user: {
    user_id: string;
    cognito_sub: string;
    email: string;
    status: string;
  };
  access_summary: MeAccessSummary;
};

// GET /xecguard/internal/v1/me — returns the caller's identity + license scope.
// BearerAuth only (no X-License-Id), so it can bootstrap the per-user license id.
// Note the path prefix is `/xecguard/internal/v1` (Internal-Admin), which differs
// from the existing Internal-UI calls under `/xecguard/v1/internal`.
export default function getMe({ token }: { token: string }): Promise<InternalResponse<MeResponse>> {
  return request()({
    url: "/xecguard/internal/v1/me",
    method: "GET",
    headers: baseAuthHeaders(token),
  }).then(
    (result: AxiosResponse<MeResponse>): InternalResponse<MeResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.message,
    success: false,
  }));
}
